export const dateFormat = 'Do MMMM YYYY h:mm:ss';

export const defaultPageSize = 50;

export const sortOrderList = [
  {
    text: 'Newest to Oldest',
    value: '-1'
  },
  {
    text: 'Oldest to Newest',
    value: '1'
  }
];

export const mailTemplatesList = [
  {
    text: 'Application Approved Email',
    value: 'COMMUNITY_ENROLMENT_APPLICATION_APPROVED'
  },

  {
    text: 'Community Enrollment Email',
    value: 'COMMUNITY_ENROLMENT_APPLICATION'
  }
];

export const receivedEmailList = [
  {
    text: 'Both',
    value: 'both'
  },
  {
    text: 'Received',
    value: 'received'
  },
  { text: 'Not received', value: 'notReceived' }
];
